import { createContext, useContext } from 'react';

export type ClickEvent = { name: 'OptionGhostButton'; caption: string } | { name: 'OptionCheckbox'; value: boolean | undefined };

interface ISelectionOptionContext {
    onItemClick: (e: ClickEvent) => void;
}

export const SelectionOptionContext = createContext<ISelectionOptionContext>({
    onItemClick: () => {
        /* empty */
    },
});

export const useSelectionOption = () => useContext(SelectionOptionContext);
